import React from 'react';
import PropTypes from 'prop-types';
import { graphql, createFragmentContainer } from 'react-relay';

// components
import PdpRespDetail from './PdpRespDetail';
import { getDetailInfo } from '../PdpSharedDetails/SharedDetailComponents';
import { detailsTitle } from '../messages/pdpDetailsMessages';

// styles
import styles from './PdpRespDetails.scss';

const NUMBER_OF_COLUMNS = 4;

function PdpRespDetails(props) {
    const { item, currency } = props;
    const details = item.pdpDetailsDisplay;
    const numberOfRows = Math.ceil(details.length / NUMBER_OF_COLUMNS);

    const detailProps = { item, currency };
    return (
        <div className={styles.wrapper}>
            <h2 className={styles.header}>{detailsTitle}</h2>
            <div className="rowFlex">
                {details.reduce(
                    (detailComponents, detail, index) => {
                        const { title: detailTitle, DetailComponent } = getDetailInfo(
                            detail,
                            item.vertical
                        );
                        if (typeof DetailComponent !== 'undefined') {
                            const columnComponents = detailComponents[detailComponents.length - 1];
                            // Add detail to column
                            columnComponents.push(
                                <PdpRespDetail title={detailTitle} key={`${detail}-${index}`}>
                                    <DetailComponent detail={detail} {...detailProps} />
                                </PdpRespDetail>
                            );
                            // check if column is full
                            if (
                                columnComponents.length === numberOfRows ||
                                index === details.length - 1
                            ) {
                                // render columnComponents in column
                                detailComponents[detailComponents.length - 1] = (
                                    <ul key={`column-${detail}`} className="colXl3 colXs6">
                                        {columnComponents}
                                    </ul>
                                );
                                // if not the last detail, then initialize next column of details
                                if (index !== details.length - 1) {
                                    detailComponents[detailComponents.length] = [];
                                }
                            }
                        }
                        return detailComponents;
                    },
                    [[]]
                )}
            </div>
        </div>
    );
}

PdpRespDetails.propTypes = {
    currency: PropTypes.string,
    item: PropTypes.object.isRequired,
};

export default createFragmentContainer(PdpRespDetails, {
    item: graphql`
        fragment PdpRespDetails_item on Item {
            pdpDetailsDisplay
            vertical
            ...PdpSharedDetailBust_item
            ...PdpSharedDetailCondition_item
            ...PdpSharedDetailCreator_item
            ...PdpSharedDetailDealerLocation_item
            ...PdpSharedDetailDealerReference_item
            ...PdpSharedDetailDiameter_item
            ...PdpSharedDetailDimensions_item
            ...PdpSharedDetailHip_item
            ...PdpSharedDetailInseam_item
            ...PdpSharedDetailLeadTime_item
            ...PdpSharedDetailLength_item
            ...PdpSharedDetailManufactureDate_item
            ...PdpSharedDetailMarkedSize_item
            ...PdpSharedDetailMaterialNotes_item
            ...PdpSharedDetailMaterialsAndTechniques_item
            ...PdpSharedDetailMedium_item
            ...PdpSharedDetailMetal_item
            ...PdpSharedDetailOrigin_item
            ...PdpSharedDetailPeriod_item
            ...PdpSharedDetailProductionType_item
            ...PdpSharedDetailReference_item
            ...PdpSharedDetailSeatHeight_item
            ...PdpSharedDetailSetSize_item
            ...PdpSharedDetailShoulderToHem_item
            ...PdpSharedDetailStone_item
            ...PdpSharedDetailStoneCut_item
            ...PdpSharedDetailStyleOf_item
            ...PdpSharedDetailVersions_item
            ...PdpSharedDetailWaist_item
            ...PdpSharedDetailWear_item
            ...PdpSharedDetailWeight_item
        }
    `,
});
